import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default {
  // 用户相关
  login(credentials) {
    return apiClient.post('/user/login', credentials);
  },

  // 店铺列表
  getStores() {
    return apiClient.get('/data/stores');
  },

  // 订单数据相关
  getData(params) {
    return apiClient.get('/data', { params });
  },
  getSingleData(id) {
    return apiClient.get(`/data/${id}`);
  },
  addData(data) {
    return apiClient.post('/data', data);
  },
  updateData(id, data) {
    return apiClient.put(`/data/${id}`, data);
  },
  deleteData(ids) {
    return apiClient.delete('/data', { data: { ids } });
  },

  // 退回表相关
  getReturns(params) {
    return apiClient.get('/return', { params });
  },
  updateReturnStatus(id, data) {
    return apiClient.put(`/return/${id}`, data);
  },

  // ========================================
  // 同步订单 API
  // ========================================

  // 同步 Shoplazza - 动漫1站 (ANI)
  syncANI() {
    return apiClient.post('/data/sync-ani');
  },
  // 同步 Shoplazza - Metaleks (CMP)
  syncCMP() {
    return apiClient.post('/data/sync-cmp');
  },
  // 同步 Shoplazza - OTA Poster (OTA)
  syncOTA() {
    return apiClient.post('/data/sync-ota');
  },
  // 同步 Shopline - Bettermelab (MPS)
  syncMPS() {
    return apiClient.post('/data/sync-mps');
  },
  // 同步 Shopify - Animetallic (ALIC)
  syncALIC() {
    return apiClient.post('/data/sync-alic');
  }
};
